<template>
  <div>
    <v-card
      class="my-1"
      style="height: 160px"
    >
      <v-card-title>My Monthly Payslip</v-card-title>
      <v-row class="px-4">
        <v-col class="py-0">
          <v-autocomplete
            v-model="companyEmployee"
            v-validate="'required'"
            :items="companies"
            item-text="company.name"
            item-value="company.id"
            label="Company"
            data-vv-as="company"
            data-vv-name="companyEmployee"
            :error-messages="errors.collect('companyEmployee')"
            :disabled="companies.length <= 0"
            return-object
            @change="loadMonths(companyEmployee.company_employee_uid)"
          />
        </v-col>
    
        <v-col class="py-0">
          <v-menu
            v-model="payrollMonthMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
            max-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="payrollMonthDisplay"
                v-validate="'required'"
                :error-messages="errors.collect('payrollMonthDisplay')"            
                :disabled="!companyEmployee"
                data-vv-name="payrollMonthDisplay"
                data-vv-as="payroll month"
                label="Payroll Month"
                readonly
                class="label-position"
                v-on="on"
              >
                <template v-slot:prepend-inner>
                  <v-icon>
                    mdi-calendar
                  </v-icon>
                </template>
              </v-text-field>
            </template>

            <v-date-picker
              v-model="payrollMonth"
              type="month"
              :allowed-dates="allowedMonths"
              scrollable
              @input="payrollMonthMenu = false"
              @change="loadPayrollCycle"
            />
          </v-menu>
        </v-col>

        <v-col class="py-0">
          <v-autocomplete
            v-model="payrollCycle"
            v-validate="'required'"
            :items="payrollCycles"
            :disabled="!companyEmployee && !payrollMonth"
            item-text="name"
            item-value="id"
            label="Payroll Cycle (Month End Salary, Bonus etc.)"
            data-vv-as="payroll cycle"
            data-vv-name="payrollCycle"
            :error-messages="errors.collect('payrollCycle')"
            return-object
          />
        </v-col>

        <v-col>
          <v-row>
            <v-btn
              class="mx-3"
              color="primary"
              :loading="loading && companyEmployee && payrollMonth && payrollCycle"
              :disabled="loading || !companyEmployee || !payrollMonth || !payrollCycle"
              @click="download"
            >
              Download
            </v-btn>
          </v-row>
        </v-col>
      </v-row> 
      <v-row
        v-if="!loading && companies.length <= 0"
        class="px-6 pb-2 mt-n3"
      >
        <v-icon
          class="pr-1"
          color="red"
        >
          mdi-information-outline
        </v-icon>
        <span class="red--text">No payslip available for download.</span>
      </v-row>
      <v-row 
        v-if="companyEmployee && payrollMonth && payrollCycle"
        class="px-6 pb-2 mt-n3 red--text"
      >
        <v-icon
          class="pr-1"
          color="red"
        >
          mdi-information-outline
        </v-icon>
        <span v-if="currentPersonCitizenshipLookupUid && currentPersonCitizenshipLookupUid != (citizenship.find(e => e.value === 'MY').lookup_uid)">
          Kindly note that this payslip is safeguarded with a password. Kindly input the last six characters of your passport number for access.
        </span>
        <span v-else>Kindly note that this payslip is safeguarded with a password. Kindly input the last six digits of your IC number for access.</span>
      </v-row>
    </v-card>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        loading: false,
        companies: [],
        dates: [],
        payrollCycleEmployees: [],
        payrollCycles: [],
        companyEmployee: null,
        payrollMonth: null,
        payrollCycle: null,
        payrollMonthMenu: false,
        currentPersonCitizenshipLookupUid: '',
      }
    },
    computed: {
      ...mapState('lookup', ['citizenship']),
      payrollMonthDisplay () {
        return this.payrollMonth ? this.$moment(this.payrollMonth + '-01', 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
    },
    created () {
      this.loadData()
      this.loadCurrentPerson()
    },
    methods: {
      loadData () {
        this.loading = true

        this.$api.employeeCompanies().list(this.employeeUid)
          .then(res => {
            this.companies = res.data

            if (this.companies.length > 1) {
              let activeCompany = res.data.filter(company => {
                return company.end_date == null || company.end_date > this.$moment().format('YYYY-MM-DD')
              })

              activeCompany = _.orderBy(activeCompany, ['start_date', 'is_active_pay_status'], ['desc', 'desc'])

              this.loadMonths(activeCompany[0].company_employee_uid)
              this.companyEmployee = activeCompany[0]
            } else if (this.companies.length === 1) {
              this.loadMonths(this.companies[0].company_employee_uid)
              this.companyEmployee = this.companies[0]
            } else {
              console.log('no payslips available')
            }

            this.loading = false
          })
      },
      loadCurrentPerson () {
        const person = (JSON.parse(localStorage.getItem('user')) || {}).person || {}
        this.currentPersonCitizenshipLookupUid = person.citizenship_lookup_uid
      },
      loadPayrollCycle () {
        this.payrollCycles = []
        this.payrollCycle = null

        this.payrollCycleEmployees.filter(payrollCycleEmployee => {
          if (payrollCycleEmployee.payroll_cycle_transaction.payroll_period.payroll_date === this.payrollMonth + '-01') {
            this.payrollCycles.push({ 
              id: payrollCycleEmployee.payroll_cycle_transaction.payroll_cycle_id, 
              name: payrollCycleEmployee.payroll_cycle_transaction.payroll_cycle.name, 
              payroll_cycle_transaction_id: payrollCycleEmployee.payroll_cycle_transaction_id,
            })
          }
        })
        
        if (this.payrollCycles.length === 1) {
          this.payrollCycle = this.payrollCycles[0]
        }
      },
      download () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.loading = true
            let payrollPeriod = this.dates.find(payrollDate => payrollDate.date === this.payrollMonth + '-01')

            this.$api.payslips().download(this.companyEmployee.company_employee_uid, this.payrollCycle.payroll_cycle_transaction_id, 'download')
              .then(res => {
                let blob = new Blob([res.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', this.$moment(payrollPeriod.date).format('MMM YYYY') + ' - ' + this.payrollCycle.name + ' payslip.pdf')
                link.click()
                this.loading = false
                this.$snack({ message: 'Payslip downloaded successfully.' })
              }).catch((e) => {
                this.loading = false
                if (e.response.status === 404) {
                  this.$snack({ color: 'error', message: 'No record found' })
                } else {
                  this.$snack({ color: 'error', message: 'Error! Something unexpected happened' })
                }
              })
          })
      },
      loadMonths (companyEmployeeUid) {
        this.dates = []
        this.payrollCycles = []
        this.payrollMonth = null
        this.payrollCycle = null
        
        this.$api.payslips().list(companyEmployeeUid)
          .then(res => {
            this.payrollCycleEmployees = res.data

            this.payrollCycleEmployees.forEach(item => {
              this.dates.push({ id: item.payroll_cycle_transaction.payroll_period_id, date: item.payroll_cycle_transaction.payroll_period.payroll_date })
            })
            
            this.dates.sort((a, b) => {
              return a.date > b.date ? -1 : 1
            })
          })
      },
      allowedMonths (val) {
        let tempMonths = []
        this.dates.forEach(payrollMonth => {
          tempMonths.push(payrollMonth.date.slice(0, -3))
        })

        if (tempMonths.indexOf(val) !== -1) {
          return true
        } else {
          return false
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px
}
</style>
